import styled from 'styled-components';

export const FooterContainer = styled.div`
  width: 100%;
  border-bottom: ${(props) => `1px solid ${props.theme.colors.greys.light}`};
`;
